import React from 'react'
import {Button, Dialog, DialogContent, DialogContentText, DialogTitle, DialogActions, Typography} from '@material-ui/core'
import {createMuiTheme, ThemeProvider} from '@material-ui/core/styles'
import DefaultImage from '../../assets/zip_notfound.png'
import DocumentImage from '../../assets/document.png'
import SponsorMissingImage from '../../assets/astronaut.png'
import {ErrorImage} from './styles'


const ERROR_MESSAGES = {
  2000: "Não é possível realizar o cadastro, verifique os dados digitados e tente novamente, em caso de dúvidas entre em contato com a central de atendimento.",
  2002: "Você parou na etapa de envio de documentos, sua conta só será aberta após envio e validação dos documentos.",
  2003: "Não é possível realizar o cadastro, ocorreu um erro inesperado, tente novamente mais tarde.",
  2006: "Sua conta foi criada com sucesso, porém ocorreu um erro ao se comunicar com o programa de pontos, por favor entre em contato com a central de atendimento.",
  2007: "Não foi possível encontrar o patrocinador, por favor verifique os dados digitados e tente novamente, em caso de dúvidas entre em contato com a central de atendimento.",
  2008: "O seu CNPJ já foi cadastrado dentro da plataforma deseja cadastrar uma subconta PJ/Fornecedor?",
  2012: "Não foi possível prosseguir com o cadastro, pois o patrocinador escontra-se inativo. Para prosseguir é necessário que o mesmo ative o programa de pontos."
}

const TITLE = {
  2002: "Envio de documentos.",
  2007: "Patrocinador não encontrado.",
  2012: "Patrocinador inativo."
}

const IMAGE = {
  2002: DocumentImage,
  2007: SponsorMissingImage,
  2012: SponsorMissingImage
}

const dialogTheme = createMuiTheme({
  typography: {
    fontFamily: 'Overpass, Arial',
  },
  palette: {
    type: 'light',
    primary: {
      light: '#18b5e1',
      main: '#5BD9F9',
      dark: '#48a7ba',
    },
    background: {
      default: '#000000'
    },
  },
  shape: {
    borderRadius: 4,
  },
  props: {
    MuiTab: {
      disableRipple: true,
    },
  },
  mixins: {
    toolbar: {
      minHeight: 48,
    },
  },
})

const CustomDialog = ({title, description, open, onClose, errorCode, image, actionText, children}) => {
  return (
    <ThemeProvider theme={dialogTheme}>
      <Dialog
        open={open}
        onClose={onClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{TITLE[errorCode] || title}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description" component="div">
            <ErrorImage src={image || IMAGE[errorCode] || DefaultImage} alt={TITLE[errorCode]}/>
            <Typography variant="body2">
              {ERROR_MESSAGES[errorCode] || description}
            </Typography>
            {errorCode && (
              <Typography variant="overline">Código de ajuda: {errorCode}</Typography>
            )}
          </DialogContentText>
          {children}
        </DialogContent>
        <DialogActions>
          <Button color="default" onClick={onClose}>{actionText}</Button>
        </DialogActions>
      </Dialog>
    </ThemeProvider>
  )
}

CustomDialog.defaultProps = {
  actionText: 'Fechar'
}

export default CustomDialog
